define('gameday-index-configurator/src/model/valueObjects/SkinConfig',['require','exports','module'],function(require, exports, module) {
	function SkinConfig(props) {

	}

	return SkinConfig;
});
